// @ts-nocheck
import { Input, Text, InputLeftAddon, InputGroup } from "@chakra-ui/react";
import React from "react";

const allowedKeys = [8, 13, 9, 37, 39];
export const handleKeyDown = (e, onKeyDown) => {
  let preventCondition =
    (!allowedKeys.includes(e.keyCode) && e.keyCode < 48) || e.keyCode > 57;

  if (preventCondition) {
    e.preventDefault();
    return;
  } else {
    onKeyDown && onKeyDown(e);
  }
};

export function transformPhoneOutput(dialCode, number) {
  let phoneWithoutPlus =
    number.charAt(0) === "+" ? number.slice(1, number.length) : number;
  let phoneHasDialCode =
    phoneWithoutPlus.slice(0, dialCode.length).search(dialCode) > -1;

  function getPhoneWithDialCode() {
    let phoneNumber = phoneWithoutPlus.slice(
      dialCode.length,
      phoneWithoutPlus.length,
    );
    let phoneStartsWithZero = phoneNumber.charAt(0) === "0";
    let actualNumber = phoneNumber.slice(1, phoneNumber.length);
    return phoneStartsWithZero
      ? "+" + dialCode + actualNumber
      : "+" + dialCode + phoneNumber;
  }

  function getPhoneWithoutDialCode() {
    let phoneStartsWithZero = phoneWithoutPlus.charAt(0) === "0";
    let actualNumber = phoneWithoutPlus.slice(1, phoneWithoutPlus.length);
    return phoneStartsWithZero
      ? "+" + dialCode + actualNumber
      : "+" + dialCode + phoneWithoutPlus;
  }

  let updatedPhoneNumber = phoneHasDialCode
    ? getPhoneWithDialCode()
    : getPhoneWithoutDialCode();

  return updatedPhoneNumber;
}

export function transformPhoneInput(dialCode, number) {
  let phoneWithoutPlus =
    number.charAt(0) === "+" ? number.slice(1, number.length) : number;
  let phoneHasDialCode =
    phoneWithoutPlus.slice(0, dialCode.length).search(dialCode) > -1;

  function getPhoneWithDialCode() {
    let phoneNumber = phoneWithoutPlus.slice(
      dialCode.length,
      phoneWithoutPlus.length,
    );
    let phoneStartsWithZero = phoneNumber.charAt(0) === "0";
    let actualNumber = phoneNumber.slice(1, phoneNumber.length);
    return phoneStartsWithZero ? actualNumber : phoneNumber;
  }

  function getPhoneWithoutDialCode() {
    let phoneStartsWithZero = phoneWithoutPlus.charAt(0) === "0";
    let actualNumber = phoneWithoutPlus.slice(1, phoneWithoutPlus.length);
    return phoneStartsWithZero ? actualNumber : phoneWithoutPlus;
  }

  let updatedPhoneNumber = phoneHasDialCode
    ? getPhoneWithDialCode()
    : getPhoneWithoutDialCode();

  return updatedPhoneNumber;
}

const PhoneInput = ({ dialCode, onKeyDown, ...rest }) => {
  return (
    <InputGroup {...rest}>
      <InputLeftAddon children={dialCode} bg="white" {...rest} />
      <Input
        type="tel"
        onKeyDown={handleKeyDown}
        borderRadius="noLeftRadius"
        {...rest}
      />
    </InputGroup>
  );
};

export default PhoneInput;

PhoneInput.defaultProps = {
  placeholder: "Enter phone number",
};
